import { render, staticRenderFns } from "./PermanentPromotion.vue?vue&type=template&id=b8912440"
import script from "./PermanentPromotion.vue?vue&type=script&lang=js"
export * from "./PermanentPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports